<template>
  <div>
    <div class="box-body form">
      <div>
        <h3>運費設定</h3>
        <div>請確認POS端是否支援此功能</div>
      </div>
      <br />
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            運費說明
            <span class="nd-tooltip">
              <ion-icon name="help-circle"></ion-icon>
              <span class="nd-tooltip-text">
                紅框處，即為「運費說明」的文字內容，將顯示於菜單頁的訂餐資訊中 。
                <img alt="運費說明圖片" src='/static/img/shipping_description.png' />
              </span>
            </span>
          </span>
          <textarea class="form-control" type="text" v-model="sInfo.shipping_description" maxlength="100"></textarea>
        </div>
        <div class="text-right">{{ sInfo.shipping_description ? sInfo.shipping_description.length : 0 }}/100</div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            運費計算
          </span>
          <select class="form-control" v-model="feeTypeSelect">
            <option :value="0">不計算運費</option>
            <option :value="1">依訂單金額計算</option>
            <option :value="2">依運送距離計算</option>
            <option :value="3">依運送距離+訂單金額計算</option>
          </select>
        </div>
        <br />
      </div>
      <div v-if="showVendorId">
        <div class="input-group">
          <span class="input-group-addon">
            POS廠商ID
          </span>
          <input class="form-control" placeholder="" type="text" v-model="vendorCustomId" maxlength="30">
        </div>
        <br />
      </div>
      <!-- 依訂單金額計算 -->
      <template v-if="feeTypeSelect === 1">
        <div class="text-left">
          <button class="btn btn-primary" @click="addItem()">新增運費</button>
          <button v-if="$route.name !== 'batchSetupStore'" class="btn btn-default pull-right" data-toggle="modal" data-target="#openModal">複製運費至其他店家</button>
        </div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>
                <span>訂單金額</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    計算商品金額 (折扣前) ，不含塑膠袋。
                  </span>
                </span>
              </td>
              <td>運費設定</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, iIndex) in itemList">
              <td>
                <template v-if="item.money === -1">
                  <template v-if="itemList[iIndex - 1]">
                    <span class="text-red">＊ </span>＄ {{maxValue(itemList, 'money') + 1}} 以上 
                  </template>
                  <template v-else>
                    <span class="text-red">＊ </span>不限金額
                  </template>
                </template>
                <template v-else>
                  <span class="text-red">＊ </span>
                  ＄ <input class="form-control w-90 inline-block" placeholder="金額" type="text" :value="itemList[iIndex - 1] ? (itemList[iIndex - 1].money * 1 + 1) : 0" disabled>
                  ～
                  ＄ <input class="form-control w-90 inline-block" placeholder="金額" type="text" v-model.number="item.money" @change="updateValue(itemList, 'money')">
                </template>
              </td>
              <td>
                <span class="text-red">＊ </span>
                運費 $ <input class="form-control w-90 inline-block" placeholder="運費" type="text" v-model.number="item.fee">
              </td>
              <td>
                <button v-if="item.money > -1" class="btn btn-danger" @click="removeItemTime(iIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <!-- End 依訂單金額計算 -->

      <!-- 運送距離計算 -->
      <template v-if="feeTypeSelect === 2">
        <p class="text-left"><span class="text-red">＊ </span> 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。</p>
        <div class="text-left">
          <button class="btn btn-primary" @click="addItem()">新增運費</button>
          <button v-if="$route.name !== 'batchSetupStore'" class="btn btn-default pull-right" data-toggle="modal" data-target="#openModal">複製運費至其他店家</button>
        </div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>運送距離</td>
              <td>運費設定</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, iIndex) in itemListKM">
              <td>
                <template v-if="item.distance === -1">
                  <template v-if="itemListKM[iIndex - 1]">
                    <span class="text-red">＊ </span>{{numeral(maxValue(itemListKM, 'distance')).add(0.1).value()}} 公里以上
                  </template>
                  <template v-else>
                    <span class="text-red">＊ </span>不限距離
                  </template>
                </template>
                <template v-else>
                  <span class="text-red">＊ </span>
                  <input class="form-control w-90 inline-block" placeholder="距離" type="text" :value="itemListKM[iIndex - 1] ? (numeral(itemListKM[iIndex - 1].distance).add(0.1).value()) : 0" disabled> 公里
                  ～
                  <input class="form-control w-90 inline-block" placeholder="距離" type="text" v-model.number="item.distance" @change="updateValue(itemListKM, 'distance')"> 公里
                </template>
              </td>
              <td>
                <span class="text-red">＊ </span>
                運費 $ <input class="form-control w-90 inline-block" placeholder="運費" type="text" v-model.number="item.fee" @change="updateValue(itemListKM, 'distance')">
              </td>
              <td>
                <button v-if="item.distance > -1" class="btn btn-danger" @click="removeItemTime(iIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <!-- End 運送距離計算 -->

      <!-- 運送距離+訂單金額計算 -->
      <template v-if="feeTypeSelect === 3">
        <p class="text-left"><span class="text-red">＊ </span> 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。</p>
        <div class="text-left">
          <button class="btn btn-primary" @click="addItem()">新增運費</button>
          <button v-if="$route.name !== 'batchSetupStore'" class="btn btn-default pull-right" data-toggle="modal" data-target="#openModal">複製運費至其他店家</button>
        </div>
        <table class="table table-bordered table-striped dataTable deliveryTable">
          <thead class="bg-primary">
            <tr>
              <td>運送距離</td>
              <td>
                <span>訂單金額</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    計算商品金額 (折扣前) ，不含塑膠袋。
                  </span>
                </span>
              </td>
              <td>運費設定</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, iIndex) in itemListKM">
              <tr :class="iIndex%2?'even':'odd'">
                <td :rowspan="item.range.length + 1">
                  <template v-if="itemList.length == 1">
                    <span class="text-red">＊ </span>不限距離
                  </template>

                  <template v-else-if="item.distance == -1">
                    <span class="text-red">＊ </span>{{numeral(maxValue(itemListKM, 'distance')).add(0.1).value()}} 公里以上
                  </template>

                  <template v-else>
                    <span class="text-red">＊ </span>
                    <input class="form-control w-90 inline-block" placeholder="距離" type="text" :value="itemListKM[iIndex - 1] ? (numeral(itemListKM[iIndex - 1].distance).add(0.1).value()) : 0" disabled> 公里
                    ～
                    <input class="form-control w-90 inline-block" placeholder="距離" type="text" v-model.number="item.distance" @change="updateValue(itemListKM,'distance')"> 公里
                  </template>
                </td>
              </tr>

              <tr v-for="(range, index) in item.range" :class="iIndex%2?'even':'odd'">
                <td>
                  <template v-if="range.money == -1">
                    <span class="text-red">＊ </span>$ {{maxValue(item.range, 'money') + 1}} 以上
                  </template>

                  <template v-else>
                    <span class="text-red">＊ </span>
                    $ <input class="form-control w-90 inline-block" placeholder="金額" type="text" :value="item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0" disabled>
                    ～
                    $ <input class="form-control w-90 inline-block" placeholder="金額" type="text" v-model.number="range.money" @click="updateValue(item.range, 'money')">
                  </template>

                  <button v-if="index==0" class="btn btn-success" @click="item.range.splice(item.range.length - 1, 0, { money: item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0, fee: 0 }); updateValue(item.range, 'money'); $forceUpdate()">
                    <i class="fa fa-plus-circle" aria-hidden="true" />
                  </button>
                </td>
                <td>
                  <span class="text-red">＊ </span>運費 $ <input class="form-control w-90 inline-block" placeholder="運費" type="text" v-model.number="range.fee">
                </td>
                <td>
                  <button v-if="range.money > -1 && (item.range.length > 2 || item.distance > -1)" class="btn btn-danger" @click="item.range.length == 2 ? removeItemTime(iIndex):item.range.splice(index, 1); $forceUpdate()"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </template>
      <!-- End 運送距離+訂單金額計算 -->
      <br>
    </div>
    <div class="modal fade" role="dialog" id="openModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">複製此分店運費至其他店家</h4>
            <p class="text-light-gray">計算類型、運費描述依然需至該店設定</p>
            <br />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12 p-x-0">
                <div>
                  <h5 class="text-left">參與店家</h5>
                  <!-- 參與店家 -->
                  <muti-select-two :setting="addStoresSetting"></muti-select-two>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="copyShipping" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'

export default {
  props: {
    resetShopping: {
      type: Boolean,
      default: false
    },
    storeInfo: {
      type: Object,
      default: () => { }
    },
    showVendorId: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      numeral,
      sInfo: {
        shipping_fee_type: 0,
        shipping_description: '',
        api_type: 1,
        setting_info: {
          vendor_custom_id: null
        }
      },
      feeTypeSelect: null,
      allShippingFee: {},
      itemList: [],
      // itemNoLimit: { money: -1, fee: 0 },
      storeBrief: [],
      addStoresSetting: {
        // jMutiSelect 用 class 當 DOM id，同頁若有其他 copy-store 會撞名導致操作到其他 copy-store 上，所以調整 class name
        class: 'copy-shipping-store',
        options: [],
        choose: []
      }
    }
  },
  methods: {
    // 強制規定金額或距離不得小於前一個級距
    updateValue (itemList, key) {
      // 如果是金額，每個級距最小值為前一個級距最大值 + 1 元
      // 如果是距離，每個級距最小值為前一個級距最大值 + 0.1 公里
      let offset = key === 'money' ? 1 : 0.1

      itemList.forEach((item, idx) => {
        if (item[key] === -1) return
        let preValue = itemList[idx - 1] ? numeral(itemList[idx - 1][key]).add(offset).value() : 0
        item[key] = item[key] * 1 < preValue ? preValue : item[key]
      })

      if (key === 'distance') this.itemListKM = itemList // 更新 itemListKM 並觸發 setter
    },
    getStoreBrief () {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var sList = response.data.list
          if (this.$route.name === 'batchSetupStore') {
            if (sList.findIndex(x => x.api_type === 1) > -1) {
              this.sInfo.api_type = 1
            }
          } else {
            for (let i = 0; i < sList.length; i++) {
              let obj = {label: sList[i].name, value: sList[i].store_id}
              if (parseInt(sList[i].store_id, 10) !== parseInt(this.$route.params.store_id, 10)) {
                this.storeBrief.push(obj)
                this.addStoresSetting.options.push(obj)
              }
            }
          }
        }
      })
    },
    copyShipping () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/syncShippingFee'
      let syncList = ''
      for (let i = 0; i < this.addStoresSetting.choose.length; i++) {
        syncList = syncList + this.addStoresSetting.choose[i] + ','
      }
      syncList = syncList.slice(0, -1)
      var data = {
        sync_store_ids: syncList
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    goToStoreTable () {
      this.$router.push('/storeTable/' + this.$route.params.brand_id)
    },
    // 增加運費級距
    addItem () {
      let defaultValue = 1
      let type = this.feeTypeSelect === 1 ? 'money' : 'distance'
      let itemList = type === 'money' ? this.itemList : this.itemListKM
      let valueOffset = type === 'money' ? 1 : 0.1 // 金額 +1 元，距離 +0.1 公里
      let prevItem = itemList[itemList.length - 2]
      // 如果有前一筆資料，則預設值為前一筆資料的值 + valueOffset
      if (prevItem && prevItem[type] !== -1) defaultValue = numeral(prevItem[type]).add(valueOffset).value()
      // 在最後一筆資料前插入一筆資料
      itemList.splice(itemList.length - 1, 0, { distance: defaultValue, money: defaultValue, fee: 0, range: [{ money: 1, fee: 0 }, { money: -1, fee: 0 }] })

      if (type === 'distance') this.itemListKM = itemList // 更新 itemListKM 並觸發 setter
      this.$forceUpdate()
    },
    // 移除運費級距
    removeItemTime (index) {
      // 如果是金額，則取 itemList，否則取 itemListKM
      let itemList = this.feeTypeSelect === 1 ? this.itemList : this.itemListKM
      itemList.splice(index, 1)
      if (this.feeTypeSelect !== 1) this.itemListKM = itemList // 更新 itemListKM 並觸發 setter
    },
    checkShipping (maxDeliveryDistanceM) {
      return new Promise((resolve, reject) => {
        var msg = ''
        if (this.feeTypeSelect !== 1 && maxDeliveryDistanceM) {
          let overLimit = this.itemList.some(item => item.distance > maxDeliveryDistanceM)
          if (overLimit) msg = '運送距離不可超過最遠可外送距離！'
        }
        if (!msg && this.feeTypeSelect === 1) {
          var moneyList = []
          this.itemList.forEach(function (obj) {
            if (!obj.money && obj.money !== 0) {
              msg = '門檻金額未填'
            } else if (!obj.fee && obj.fee !== 0) {
              msg = '運費金額未填'
            } else if (typeof moneyList.find(function (money) { return money === obj.money }) !== 'undefined') {
              msg = '門檻金額重複'
            } else {
              moneyList.push(obj.money)
            }
          })
        }

        if (this.sInfo.api_type === 1 && this.sInfo.setting_info && !this.sInfo.setting_info.vendor_custom_id && this.feeTypeSelect !== 0) {
          msg = '設定 API 服務類型為專屬客製 POS，需要填寫 POS 廠商 ID'
        }
        if (msg) {
          this.$notify({
            title: '提醒',
            text: msg,
            duration: 3000,
            type: 'danger',
            width: 400
          })
          reject(msg)
        } else {
          resolve()
        }
      })
    },
    maxValue (list, key) {
      if (!list.length) return 0
      let values = list.map((obj) => obj[key])
      return Math.max(...values)
    },
    getShippingFee () {
      var url = '/store/' + this.$route.params.store_id + '/shippingFee'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.sInfo = response.data
          this.feeTypeSelect = this.sInfo.shipping_fee_type
          this.itemList = []
          this.allShippingFee = this.sInfo.all_shipping_fee_type
          this.sInfo.setting_info.item_list.forEach((obj, idx) => {
            let isLast = idx === this.sInfo.setting_info.item_list.length - 1
            if (!obj.money) obj.money = isLast ? -1 : 0
            if (!obj.distance) obj.distance = isLast ? -1 : 0

            if (!obj.range) obj.range = [{money: 0, fee: 0}, { money: -1, fee: 0 }]
            obj.range.forEach((range, rIdx) => {
              if (!range.money) range.money = rIdx === obj.range.length - 1 ? -1 : 0
            })

            this.itemList.push(obj)
          })
        }
      })
    },
    async upShippingFee (newStoreId) {
      let data = {}

      if (this.sInfo.setting_info && this.sInfo.setting_info.vendor_custom_id) data.vendor_custom_id = this.sInfo.setting_info.vendor_custom_id

      if (this.feeTypeSelect !== 99) {
        let newItemList = []
        // 運費排序
        this.itemList.sort((a, b) => {
          switch (this.feeTypeSelect) {
            case 1:
              if (a.money === -1) return 1
              return a.money - b.money
            case 2:
              if (a.distance === -1) return 1
              return a.distance - b.distance
            case 3:
              if (a.distance === -1) return 1
              return a.distance - b.distance
          }
        })
        if (this.feeTypeSelect === 3) {
          this.itemList.forEach((obj) => {
            obj.range.sort((a, b) => {
              if (a.money === -1) return 1
              return a.money - b.money
            })
          })
        }

        // End 運費排序
        this.itemList.forEach((obj) => {
          newItemList.push(obj)
        })

        data.item_list = newItemList
      }
      data.shipping_description = this.sInfo.shipping_description
      data.shipping_fee_type = this.feeTypeSelect

      switch (this.feeTypeSelect) {
        case 0:
          delete data.item_list
          break
        case 1:
          data.item_list.forEach((obj) => {
            delete obj.distance
            delete obj.range
          })
          break
        case 2:
          data.item_list.forEach((obj) => {
            delete obj.money
            delete obj.range
          })
          break
        case 3:
          data.item_list.forEach((obj) => {
            delete obj.money
          })
          break
      }

      if (this.$route.name === 'batchSetupStore') {
        data = {
          shipping_fee_setting: data,
          store_list: this.$parent.includeStoresSetting.choose.toString()
        }

        if (!data.shipping_fee_setting.shipping_fee_type) delete data.shipping_fee_setting.shipping_fee_type
        if (!data.shipping_fee_setting.shipping_description) delete data.shipping_fee_setting.shipping_description
        if (!data.shipping_fee_setting.item_list.length) delete data.shipping_fee_setting.item_list
        if (Object.keys(data.shipping_fee_setting).length === 0) delete data.shipping_fee_setting
      }

      let url = ''
      if (this.$route.name === 'batchSetupStore') {
        url = '/brand/' + this.$route.params.brand_id + '/syncStore/create'
        return await this.getDataH('post', url, data)
      } else {
        const storeId = newStoreId || this.$route.params.store_id
        url = '/store/' + storeId + '/shippingFee'
        return await this.getDataH('put', url, data)
      }
    }
  },
  created () {
    if (this.$route.name !== 'batchSetupStore' && this.$route.name !== 'crStore') {
      this.getShippingFee()
    }
    if (this.storeInfo) this.sInfo = this.storeInfo
    this.getStoreBrief()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    itemListKM: { // 轉換成公里
      get () {
        return this.itemList.map((obj) => {
          let newObj = {...obj}
          if (newObj.distance && newObj.distance !== -1) newObj.distance = numeral(newObj.distance).divide(1000).value()
          return newObj
        })
      },
      set (value) {
        this.itemList = value.map((obj, idx) => {
          let newObj = {...obj}
          if (newObj.distance && newObj.distance !== -1) newObj.distance = numeral(value[idx].distance).multiply(1000).value()
          return newObj
        })
      }
    },
    vendorCustomId: {
      get () {
        if (!this.sInfo.setting_info || !this.sInfo.setting_info.vendor_custom_id) return null
        return this.sInfo.setting_info.vendor_custom_id
      },
      set (value) {
        if (!this.sInfo.setting_info) this.sInfo.setting_info = {}
        this.sInfo.setting_info.vendor_custom_id = value
      }
    }
  },
  watch: {
    sInfo: {
      handler (val) {
        this.$emit('update:storeInfo', val)
      },
      deep: true
    },
    resetShopping (val) {
      this.sInfo = {
        shipping_fee_type: 0,
        shipping_description: '',
        api_type: 1
      }

      this.feeTypeSelect = null

      if (this.$route.name !== 'batchSetupStore') {
        this.sInfo.setting_info = {
          vendor_custom_id: null
        }
      }
    },
    // 監控運費計算方式的變化
    feeTypeSelect (val) {
      // 如果有之前的設定記錄則使用設定記錄
      if (
          (this.allShippingFee && this.allShippingFee[val]) ||
          (this.sInfo &&
          this.sInfo.shipping_fee_type === val &&
          this.sInfo.setting_info &&
          this.sInfo.setting_info.item_list &&
          this.sInfo.setting_info.item_list.length)
        ) {
        this.itemList = []

        let shippingFee = this.allShippingFee[val]

        if (shippingFee && shippingFee.item_list) {
          let stringData = JSON.stringify(shippingFee.item_list)
          stringData = stringData.replace(/null/g, '-1')
          this.itemList = JSON.parse(stringData)
          return
        }

        this.sInfo.setting_info.item_list.forEach((obj, idx) => {
          let isLast = idx === this.sInfo.setting_info.item_list.length - 1
          if (!obj.money) obj.money = isLast ? -1 : 0
          if (!obj.distance) obj.distance = isLast ? -1 : 0

          if (!obj.range) obj.range = [{money: 0, fee: 0}, { money: -1, fee: 0 }]
          obj.range.forEach((range, rIdx) => {
            if (!range.money) range.money = rIdx === obj.range.length - 1 ? -1 : 0
          })

          this.itemList.push(obj)
        })
      } else {
        // 如果沒有舊資料，則新增一筆空資料
        switch (val) {
          case 1:
            this.itemList = [{ money: -1, fee: 0 }]
            break
          case 2:
            this.itemList = [{ distance: -1, fee: 0 }]
            break
          case 3:
            this.itemList = [{ distance: -1, range: [{money: 0, fee: 0}, { money: -1, fee: 0 }] }]
            break
          default:
            this.itemList = []
            break
        }
      }
    }
  }
}
</script>
<style type="scss" scoped>
.deliveryTable tbody {
  tr {
    display: table-row !important;
    &.odd {
      background: #f9f9f9;
    }
    &.even {
      background: #fff;
    }
  }
  td[rowspan]{
    vertical-align: middle;
    border-right: 1px solid rgb(244, 244, 244);
  }
}
</style>



// WEBPACK FOOTER //
// ShippingForm.vue?3adc7510